import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { EScreenZone } from './e_screen_zone';
import { ViewHintShortcut } from './ViewHintShortcut';

interface HintKeyboardGroupProps {
  rendering_hints: IHintShortcutData[];
  zone: EScreenZone;
  is_adding_hints?: boolean;
}

export const ViewHintShortcutGroup: React.FC<HintKeyboardGroupProps> = ({ rendering_hints, zone, is_adding_hints }) => {
  const position_class = zone === EScreenZone.BOTTOM ? 'bottom-2' : 'top-2';

  const ordered_hints = zone === EScreenZone.BOTTOM ? [...rendering_hints].reverse() : rendering_hints;

  const flex_direction = zone === EScreenZone.BOTTOM ? 'flex-col' : 'flex-col-reverse';

  const should_animate_layout = useMemo(() => !(zone === EScreenZone.BOTTOM && is_adding_hints), [is_adding_hints, zone]);

  return (
    <div className={`absolute ${position_class} left-1/2 -translate-x-1/2 z-[100] flex  items-center justify-center cursor-default w-[500px] h-auto`}>
      <motion.div layout={should_animate_layout} className={` flex ${flex_direction} items-center justify-start gap-1 w-max`}>
        <AnimatePresence>
          {ordered_hints.map(item => (
            <ViewHintShortcut key={`hint_shortcut_${item.key}_${zone}`} hint_data={item} />
          ))}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};
